<template>
  <div>
    <div class="welcome">
      <div v-if="isLoading"></div>

      <div v-else>
        <div>
          <h3 class="title">
            {{ $t("addToHomeScreen.install_app") }}
          </h3>
        </div>
        <div>
          <div v-if="showiOSModal" class="content-container">
            <iframe
              style="height: 100%; width: 100%;"
              src="https://www.youtube.com/embed/TMX46ia6i_4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            >
            </iframe>
          </div>
          <div v-else-if="showAndroidManual" class="content-container">
            <iframe
              style="height: 100%; width: 100%;"
              src="https://www.youtube.com/embed/OPRrk5oXXCY"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            >
            </iframe>
          </div>
          <div v-else-if="showAndroidAutomat" class="content-container"></div>
        </div>
        <div class="actions-wrapper">
          <div
            class="fullBtn"
            @click="addToHomeScreen"
            v-if="showAndroidAutomat"
          >
            <button class="modal-button">
              {{ $t("addToHomeScreen.add_to_homescreen") }}
            </button>
          </div>
          <div
            class="fullBtn"
            @click="confirmiOSAdded"
            v-if="showiOSModal || showAndroidManual"
          >
            <button>{{ $t("addToHomeScreen.saw_video") }}</button>
          </div>
          <div class="ignore-container">
            <p @click="ignoreHomeScreen" class="ignore-button">
              {{ $t("addToHomeScreen.dont_install") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../Shared/style.scss";
import "./AddToHomeScreen.scss";

export default {
  data() {
    return {
      userPlatform: "", // 'desktop', 'android', 'ios'
      showAndroidAutomat: false,
      showAndroidManual: false,
      showiOSModal: false,
      deferredPrompt: null,
      isLoading: true
    };
  },
  watch: {
    deferredPrompt() {
      if (this.userPlatform === "desktop" || this.userPlatform === "android") {
        this.handleAndriond();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.userPlatform = this.detectPlatform();
      console.log(`${this.userPlatform} platform detected.`);

      if (this.userPlatform === "ios") {
        this.handleIOS();
      } else if (
        this.userPlatform === "desktop" ||
        this.userPlatform === "android"
      ) {
        this.handleEvent();
      }
    });
  },
  methods: {
    detectPlatform() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.includes("android")) {
        return "android";
      } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
        return "ios";
      } else {
        return "desktop";
      }
    },
    handleEvent() {
      window.addEventListener("beforeinstallprompt", event => {
        event.preventDefault();
        this.deferredPrompt = event;
      });
      if (this.deferredPrompt == null) {
        this.deferredPrompt = false;
      }
    },
    async handleAndriond() {
      this.isLoading = false;
      const addedToHomeScreen = localStorage.getItem("addedToHomeScreen");
      if (this.deferredPrompt) {
        this.showAndroidManual = false;
        this.showAndroidAutomat = true;
      } else if (!addedToHomeScreen) {
        this.showAndroidManual = true;
      } else {
        this.goHome();
      }
      //  Workaround to push credentials to cache for IOS users on PWA
    },
    handleIOS() {
      this.isLoading = false;
      const addedToHomeScreen = localStorage.getItem("addedToHomeScreen");

      caches
        .open("auth")
        .then(cache =>
          cache.put("/refresh", new Response(localStorage.engrefresh))
        );
      if (!addedToHomeScreen) {
        this.showiOSModal = true;
      }
    },
    ignoreHomeScreen() {
      localStorage.setItem("addedToHomeScreen", "true");
      this.goHome();
    },
    async addToHomeScreen() {
      this.deferredPrompt.prompt();
      let results = await this.deferredPrompt.userChoice;
      if (results.outcome == "accepted") {
        localStorage.setItem("addedToHomeScreen", "true");
        this.goHome();
      } else {
        this.$forceUpdate();
      }
    },
    confirmiOSAdded() {
      localStorage.setItem("addedToHomeScreen", "true");
      this.goHome();
    },
    goHome() {
      this.$router.push({path: "/", query: this.$route.query});
    }
  }
};
</script>

<style scoped>
.iframe-container {
  text-align: center;

  iframe {
    height: 50vh;
  }
}

.content-container {
  height: 50vh;
  margin-bottom: 5vh;
}

.ignore-container {
  text-align: center;

  .ignore-button {
    color: var(--button-primary);
    font-size: 18px;
  }
}

#addToHomeScreenModal {
  z-index: 99999999;
  padding: 36px 32px 24px 32px;
  margin: auto;
  border-radius: 8px;
  width: calc(100vw - 36px);
  max-width: 328px;
}

#addToHomeScreenModal::backdrop {
  background-color: rgba(0, 0, 0, 0.8);
}

.actions-wrapper {
  margin-top: auto;
}

.close-button {
  position: absolute;
  right: 12;
  font-size: 16px;
  position: absolute;
  right: 14px;
  top: 12px;
}

.title {
  margin-top: 12px;
  line-height: 1.5 !important;
  font-size: 28px !important;
  font-weight: bold;
  font-family: fredoka !important;
}

.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

p {
  font-size: 16px;
  margin-top: 24px;
}

.modal-button {
  font-size: 18px;
  font-weight: bold;
  background: var(--button-primary);
  color: var(--button-primary-text);
  padding: 8px 18px;
  border-radius: 8px;
  width: 100%;
  height: 48px;
}
</style>



// WEBPACK FOOTER //
// AddToHomeScreen.vue?2e26852e